<template>
    <div>
        <el-form :inline="true" :model="systemOrderForm" class="forTbFilter" @submit.native.prevent>            
            <el-form-item label="代理商名称：">
                <el-input v-model="systemOrderForm.agentName"  clearable></el-input>
            </el-form-item>
            <el-form-item label="卡号：">
                <el-input v-model="systemOrderForm.cardNo"></el-input>
            </el-form-item>
            <el-form-item label="运营商：">
                <el-select v-model="systemOrderForm.operator">
                    <el-option value="1">11111</el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="支付状态：">
                <el-select v-model="systemOrderForm.payState">
                    <el-option label="全部" value="0"></el-option>
                    <el-option label="已支付" value="1"></el-option>
                    <el-option label="已退款" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="操作时间：" class="dateRange">
                <el-date-picker v-model="systemOrderForm.date" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary">搜索查询</el-button>
                <el-button type="success">导出Excel</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tableData" border height="628px" @selection-change="handleSelectionChange">
            <el-table-column prop="234" label="序号"></el-table-column>            
            <el-table-column type="selection" width="55"></el-table-column>           
            <el-table-column prop="2" label="卡号 "></el-table-column>
            <el-table-column prop="3" label="接入号 "></el-table-column>
            <el-table-column prop="4" label="代理商名称 "></el-table-column>
            <el-table-column prop="5" label="套餐名"></el-table-column>
            <el-table-column prop="6" label="套餐类型 "></el-table-column>
            <el-table-column prop="7" label="订购数量"></el-table-column>
            <el-table-column prop="8" label="实际支付金额 "></el-table-column>
            <el-table-column prop="9" label="运营商 "></el-table-column>
            <el-table-column prop="10" label="卡过期时间 "></el-table-column>
            <el-table-column prop="11" label="下单时间"></el-table-column>
            <el-table-column prop="23" label="支付状态"></el-table-column>
            <el-table-column prop="234" label="退款时间"></el-table-column>
            <el-table-column prop="234" label="退款人"></el-table-column>
            <el-table-column prop="234" label="操作"></el-table-column>
        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[100, 200, 300, 400]"
            :page-size="100"
            layout="total, sizes, prev, pager, next, jumper"
            :total="400">
        </el-pagination>        
    </div>
</template>
<script>
export default {
    data(){
        return {
            systemOrderForm: {
                date: '',
                agentName: ''
            },
            tableData: [
                {
                    2: '123123',
                    3: 'aaaaaaa',
                    4: 'ooooooo'
                },
                {
                    2: 'q123123',
                    3: 'qaaaaaaa',
                    4: 'qooooooo'
                }
            ],
            multipleSelection: []
        }
    },
    methods: {
        handleSelectionChange(val){
            this.multipleSelection = val;
        }
    }
}
</script>
<style lang="less" scoped>

</style>

